export default {
    props: {
        TransLog_Edit:Object,
        fileList2:Array,
        isNew2:Boolean,
        showcontinue:Boolean,
    },
    data() {
        return {
            TransLog: [{'id':0}],
            customers:[],
            carriers:[],
            statusItems:[
                {Id:'C',Text:'无异常'},
                {Id:'L',Text:'多货'},
                {Id:'M',Text:'少货'},
                {Id:'N',Text:'未签收'}
            ],
            TransLog_Imgs:[],
            rstatusitems:[
                {Id:'Y',Text:'已回'},
                {Id:'N',Text:'未回'}
            ],
            fileaction:'',
            reasons:[
                {Id:'R0001',Desc:'未出货'},
                {Id:'R0002',Desc:'保质期'},
                {Id:'R0003',Desc:'破损'},
                {Id:'R0004',Desc:'多货'},
                {Id:'R0005',Desc:'条码异常'},
                {Id:'R0006',Desc:'内包装缺少'},
                {Id:'Other',Desc:'其他'},
            ],

            BackRemarkItems:[
                {Id:'Y',Desc:'已结束'},
                {Id:'N',Desc:'未结束'},
            ],
            dialogImageUrl: '',
            dialogVisible: false,
            showcontinue:false,
            isNew:true,
            mainEdit:true,
            remark2Edit:false,
        }
    },
    mounted () {
        
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
        }
        
        this.mainEdit = user.BT_Edit;
        this.remark2Edit = user.BTRemark2_Edit;

        console.log(this.mainEdit);

        this.getcustomers();
        this.getcarriers();
        sessionStorage.setItem('saveornot', 'N');
        var hostURL = this.$axios.defaults.baseURL;

        this.fileaction = hostURL+ "upload/postfile";
        
        if(this.TransLog_Edit == null || this.TransLog_Edit == undefined)
        {
            this.isNew = true;
            

            var exceptions = [];
            exceptions.push({
                Id:0,
                BillNo:'',
                ProCode:'',
                ProName:'',
                SkuNo:'',
                DiffCount:null,
                ProcessRemark:'',
                BackRemark:'',
                BusinessTransId:'',
                Reason:'',
                
            });

            this.TransLog = {
                GoodsStatus:'未签收',
                ReceiptStatus:'N',
                DeveliverDt:new Date(),
                TransLogExps:exceptions
            };
        }
        else
        {
            this.isNew = this.isNew2;
            this.refreshData();
        }
    },
    watch: {
        'TransLog_Edit.Id':{
            handler(newId, oldId) 
            {
                if(newId!=oldId)
                {
                    this.refreshData();
                }
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeeBack':{
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeeBasic': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeeDeliver': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeeOp': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeePackage': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeePickup': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.FeeGoodsPrice': {
            handler(newName, oldName) 
            {
                this.calTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeeBack':{
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeeBasic': {
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeeDeliver': {
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeeOp': {
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeePackage': {
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
        'TransLog.CFeePickup': {
            handler(newName, oldName) 
            {
                this.calCTotalAmt();
            },
        deep: false,
        immediate: false
        },
    },
    methods: {
        refreshData(){
            this.TransLog = this.TransLog_Edit;
            this.TransLog_Imgs = this.fileList2;
           // this.TransLog.GoodsStatus = '未签收';
            var images = [];
            this.fileList2.forEach(element=>{
                images.push({
                    'Id':element.Id,
                    'BusinessTransId':element.BusinessTransId,
                    'FileName':element.name,
                    'FileGuid': element.url,
                })
            });

            this.TransLog_Imgs = images;
        },
        handlecontinue(){
            this.showcontinue = false;

            //this.TransLog = [{'Id':0,}];
            
            this.TransLog_Imgs = [];
            var exceptions = [];
            
            exceptions.push({
                Id:0,
                BillNo:'',
                ProCode:'',
                ProName:'',
                SkuNo:'',
                DiffCount:null,
                ProcessRemark:'',
                BackRemark:'',
                BusinessTransId:'',
                Reason:''
            });

            //this.TransLog.TransLogExps = exceptions;
            this.TransLog = {
                GoodsStatus:'未签收',
                ReceiptStatus:'N',
                DeveliverDt:new Date(),
                TransLogExps:exceptions
            };
        },

        calTotalAmt(){
            var me = this;
            var total = 0;
            if(me.TransLog.FeeBack != 'undefined' && me.TransLog.FeeBack!=null && me.TransLog.FeeBack != '')
            {
                total+=me.TransLog.FeeBack;
            }
            if(me.TransLog.FeeBasic != 'undefined' && me.TransLog.FeeBasic!=null && me.TransLog.FeeBasic != '')
            {
                total+=me.TransLog.FeeBasic;
            }
            if(me.TransLog.FeeDeliver != 'undefined' && me.TransLog.FeeDeliver!=null && me.TransLog.FeeDeliver != '')
            {
                total+=me.TransLog.FeeDeliver;
            }
            if(me.TransLog.FeeOp != 'undefined' && me.TransLog.FeeOp!=null && me.TransLog.FeeOp != '')
            {
                total+=me.TransLog.FeeOp;
            }
            if(me.TransLog.FeePackage != 'undefined' && me.TransLog.FeePackage!=null && me.TransLog.FeePackage != '')
            {
                total+=me.TransLog.FeePackage;
            }
            if(me.TransLog.FeePickup != 'undefined' && me.TransLog.FeePickup!=null && me.TransLog.FeePickup != '')
            {
                total+=me.TransLog.FeePickup;
            }
            if(me.TransLog.FeeGoodsPrice != 'undefined' && me.TransLog.FeeGoodsPrice!=null && me.TransLog.FeeGoodsPrice != '')
            {
                me.TransLog.FeeInsu = me.TransLog.FeeGoodsPrice * 0.001;
                total+=me.TransLog.FeeInsu;
            }
            me.TransLog.FeeTotal = total;
        },
        calCTotalAmt(){
            var me = this;
            var total = 0;
            if(me.TransLog.CFeeBack != 'undefined' && me.TransLog.CFeeBack!=null && me.TransLog.CFeeBack != '')
            {
                total+=me.TransLog.CFeeBack;
            }
            if(me.TransLog.CFeeBasic != 'undefined' && me.TransLog.CFeeBasic!=null && me.TransLog.CFeeBasic != '')
            {
                total+=me.TransLog.CFeeBasic;
            }
            if(me.TransLog.CFeeDeliver != 'undefined' && me.TransLog.CFeeDeliver!=null && me.TransLog.CFeeDeliver != '')
            {
                total+=me.TransLog.CFeeDeliver;
            }
            if(me.TransLog.CFeeOp != 'undefined' && me.TransLog.CFeeOp!=null && me.TransLog.CFeeOp != '')
            {
                total+=me.TransLog.CFeeOp;
            }
            if(me.TransLog.CFeePackage != 'undefined' && me.TransLog.CFeePackage!=null && me.TransLog.CFeePackage != '')
            {
                total+=me.TransLog.CFeePackage;
            }
            if(me.TransLog.CFeePickup != 'undefined' && me.TransLog.CFeePickup!=null && me.TransLog.CFeePickup != '')
            {
                total+=me.TransLog.CFeePickup;
            }
            me.TransLog.CFeeTotal = total;
        },
        getcustomers(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "common/getcustomerlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.customers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        getcarriers(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }
            var getMethod = "common/getcarrierlist/"+ user.TokenId;

            this.$axios.get(getMethod)
            .then((response) => {
                if (response.status === 200) {
                    if(response.data.IsSuccess)
                    {
                        me.carriers = response.data.Data;
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
                }
            })
            .catch(function (error) {
                console.log(error)
            });
        },
        beforeUpload(){},
        
        handlePictureCardPreview(file){
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;

        },
        handleRemove(file, fileList) {
            var images = [];
            fileList.forEach(element=>{
                images.push({
                    'Id':element.Id,
                    'BusinessTransId':element.BusinessTransId,
                    'FileName':element.name,
                    'FileGuid': element.url,
                })
            });

            this.TransLog_Imgs = images;
        },
        handlePreview(file) {
        },
        handleAddExp(){
            this.TransLog.TransLogExps.push({
                Id:0,
                BillNo:'',
                ProCode:'',
                ProName:'',
                SkuNo:'',
                DiffCount:null,
                ProcessRemark:'',
                BackRemark:'',
                BusinessTransId:'',
                Reason:'',
            });
        },
        handleclose(){
            
        },
        
        FormatDate(date_str)
        {
            if (date_str === undefined) {
              return "";
            }
            var date = new Date(date_str);
            return date.Format("yyyy-MM-dd");
        },
        submitform(){
            var me = this;
            var user = sessionStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }

            //Images
            var images = [];
            me.TransLog_Imgs.forEach(element=>{
                images.push({
                    'Id':element.Id,
                    'BusinessTransId':element.BusinessTransId,
                    'FileName':element.FileName,
                    'FileGuid': element.FileGuid,
                })
            });
            var method = "BusinessTrans/save";
            
            var storeDate = me.FormatDate( me.TransLog.StoreDt);
            var devDate = me.FormatDate(me.TransLog.DeveliverDt);
            this.$axios.post(method,{
                'CurrentTokenId': user.TokenId,
                'CurrentUser': user.LoginName,  
                'Id': me.TransLog.Id,
                'CustomerId': me.TransLog.CustomerId,
                'DeveliverDt': devDate,
                'Destination': me.TransLog.Destination,
                'StoreDt': storeDate,
                'Receiver': me.TransLog.Receiver,
                'ReceiverPhone': me.TransLog.ReceiverPhone,
                'ReceiverAddress': me.TransLog.ReceiverAddress,
                'CarrierId': me.TransLog.CarrierId,
                'BillNo': me.TransLog.BillNo,
                'BillNo2': me.TransLog.BillNo2,
                'GoodsCount': me.TransLog.GoodsCount,
                'GoodsStatus': me.TransLog.GoodsStatus,
                'GoodsCube': me.TransLog.GoodsCube,
                'GoodsWeight': me.TransLog.GoodsWeight,
                'Comment': me.TransLog.Comment,
                'Remarks': me.TransLog.Remarks,
                'Remark2': me.TransLog.Remark2,
                'Terminalinventory': me.TransLog.Terminalinventory,
                'ReceiptStatus': me.TransLog.ReceiptStatus,
                'FeeBasic': me.TransLog.FeeBasic,
                'FeePickup': me.TransLog.FeePickup,
                'FeeDeliver': me.TransLog.FeeDeliver,
                'FeeOp': me.TransLog.FeeOp,
                'FeeBack': me.TransLog.FeeBack,
                'FeePackage': me.TransLog.FeePackage,
                'FeeInsu': me.TransLog.FeeInsu,
                'FeeGoodsPrice': me.TransLog.FeeGoodsPrice,
                'FeeTotal': me.TransLog.FeeTotal,
                'CFeeBasic': me.TransLog.CFeeBasic,
                'CFeePickup': me.TransLog.CFeePickup,
                'CFeeDeliver': me.TransLog.CFeeDeliver,
                'CFeeOp': me.TransLog.CFeeOp,
                'CFeeBack': me.TransLog.CFeeBack,
                'CFeePackage': me.TransLog.CFeePackage,
                'CFeeTotal': me.TransLog.CFeeTotal,
                'TransLogExps':me.TransLog.TransLogExps,
                'TransLogImages': images,
                'PO': me.TransLog.PO,
                'BillNo3': me.TransLog.BillNo3,
            })
            .then((response) => {
                    if(response.data.IsSuccess)
                    {
                        this.showcontinue = true;
                        sessionStorage.setItem('saveornot', 'Y');
                    }
                    else
                    {
                        var strMsg = '';
                        response.data.Messages.forEach(element => {
                            strMsg += element.Message +'\r\n';
                        });
                        
                        this.alert(strMsg);
                    }
            })
            .catch(function (error) {
                this.alert(error);
            });
        },
        handleAvatarSuccess(res, file){
            
            this.TransLog_Imgs.push({
                Id:0,
                BusinessTransId:this.TransLog.Id,
                FileName:file.name,
                FileGuid: file.response[0]
            });
        },
        handleDelete(index, row) {
            var exceptions = [];
            var curIndex = 0;
            this.TransLog.TransLogExps.forEach(element=>{
                if(curIndex!=index){
                    exceptions.push(element);
                }
                curIndex++;
            });

            this.TransLog.TransLogExps = exceptions;
          },
    }
}


// WEBPACK FOOTER //
// ./src/components/NewTrans/NewTrans.js